import React, { useState, useMemo, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
  Box,
  FormControl,
  InputLabel,
  TableFooter,
  TablePagination,
  Button,
  IconButton,
  Tooltip,
  Tab,
  Tabs,
} from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { InputTextarea } from "primereact/inputtextarea";
import RulePage from "./RulesPage";
import Instructions from "./Instructions";
import ValidationRules from "./validationRules";
import { download_ManageRules, getRules } from "../services/managerules.service";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface DataRow {
  payScaleType: string;
  ruleNumber: string;
  name: string;
  description: string;
}

type Rule = {
  payScaleType: string;
  ruleNumber: string;
  name: string;
  description: string;
  warning?: string;
};



function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageRules = (props: any) => {
  const [value, setValue] = React.useState(0);
  const [rules, setRules] = React.useState([]);
  const [instructionsData, setInstructionsData] = useState(props.data || []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rulesData = await getRules();
        setRules(rulesData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  const downloadManageRules = async () => {
    const blob = await download_ManageRules();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ManageRules.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  }


  // Action handlers (placeholder)

  return (
    <>
      <div className="page-header-container">
        <div className="left-section">
          <div className="page-heading-section">
            <label className="div-txt-heading">Manage Rules</label>
            <p className="page-subheading">
              Add, modify or delete instructions & validation rules
            </p>
          </div>
        </div>
        <div className="right-section">
          <Button
            className="right-button"
            variant="contained"
            sx={{ textTransform: "none", backgroundColor: "#007CB0" }}
            onClick={downloadManageRules}
          >
            Download
          </Button>
        </div>
      </div>

      <Box sx={{ padding: "0px 72px 72px 72px" }}>
        <Box sx={{ borderBottom: 1, borderColor: "#2F3337" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Instructions"
              {...a11yProps(0)}
              sx={{
                color: "#939393", // Default text color
                "&.Mui-selected": {
                  color: "#A0DCFF", // Text color when selected
                }, textTransform: "none"
              }}
            />
            <Tab
              label="Validation Rules"
              {...a11yProps(1)}
              sx={{
                color: "#939393", // Default text color
                "&.Mui-selected": {
                  color: "#A0DCFF", // Text color when selected
                }, textTransform: "none"
              }}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Instructions
            data={instructionsData}
            setData={setInstructionsData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ValidationRules
            data={rules}
            setData={setRules}
          />
        </CustomTabPanel>
      </Box>

    </>
  );
};

export default ManageRules;
